import React from 'react'
import _ from 'lodash'
import { VictoryChart, VictoryStack, VictoryPortal, VictoryLabel, VictoryBar, VictoryAxis, VictoryTheme } from 'victory';
const grapht = (props) => {
  var data = []
  var base = []
  var val = [10,20,30,40,50,60]
  var domain = props.domain
  var media, size
     data = [{Control: 'C 0', pa:30}, {Control: 'C 1', pa: 40},{Control: 'C 2', pa: 35}]
     base = [{Control: 'C 0', pa:100}, {Control: 'C 1', pa: 100},{Control: 'C 2', pa: 100}]
     media = [{month: "C 0", media: 120},{month: "C 1", media: 100},{month: "C 2", media: 100},{month: "C 3", media: 100},{month: "C 4", media: 100}]
     if(props.data){
      data = []
      base = []
      val = []
      let checklist = props.checklist
      var arr = props.data
      arr.map((e,i) => {
        console.log(e,i,checklist[i])
          if(checklist[i] !== 'none'){
            data.push({x: i+2, y: e,label: e})
            base.push({x: i+2,y: (100-e),label:( 100 -e)})
            val.push(i+2)
          }
      })
     }
    //  base= [{x:1,y:70, label:70}, {x:2, y:90, label:90}]
    //  data= [{x:1,y:30, label:30}, {x:2, y:10, label:10}]
    //  val = [3,5]
  return (
  <div className="themeChart">
  <VictoryChart domainPadding={40}
  theme={VictoryTheme.material}
  >
  <VictoryAxis
  style={{
    tickLabels: {fill: 'white'},
    ticks: {stroke: 'white'}
  }}
  tickValues={val}
  tickFormat={(x) => `${x-2}` }
  />
    <VictoryAxis dependentAxis
          domain= {domain}
          tickFormat = {(y) => (`${y} %`)}
          style={{
            axis: {stroke: "rgba(250,250,250,1)"},
            axisLabel: {fontSize: 12, fill: 'white'},
            ticks: {stroke: 'white'},
            tickLabels: {
              fill: 'white'
            }
          }}
    />
  <VictoryStack
    colorScale={["rgba(134,195,0,0.8)", "rgba(198,31,40,0.8)"]}
    style={{
      data: { width: 30 },
      labels: { padding: -20 }
    }}
    labelComponent={
      <VictoryPortal>
        <VictoryLabel/>
      </VictoryPortal>
    }
  >

    <VictoryBar
      style={{ labels: {fontSize: 12,fill: 'white'}}}
      data={data}
    />
    <VictoryBar
      style={{ labels: {fontSize: 12,fill: 'white'}}}
      data={base}
    />
  </VictoryStack>


</VictoryChart>
</div>
  )
}
export default (props) => {
  return <g>{grapht(props)}</g>
}



// WEBPACK FOOTER //
// ./src/components/ViewStatics/ViewBar.js